import { WarningAmberOutlined } from '@mui/icons-material'
import { Box, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { imnooEstimationSummarySelector } from '../store/selectors/imnooEstimationSelectors'

export function ProjectPriceStatus() {
  const { unresolved, pending, failed } = useAppSelector(
    imnooEstimationSummarySelector,
  )
  const { t } = useTranslation()
  if (!unresolved) return null

  const affectedParts = t('project:price-incomplete-part-types', {
    defaultValue:
      unresolved === 1
        ? '{{count}} part type has unresolved estimates.'
        : '{{count}} part types have unresolved estimates.',
    count: unresolved,
  })
  const explanation = [
    pending
      ? t('project:price-incomplete-pending', {
          defaultValue:
            'Estimates are still in progress. The price will update automatically.',
        })
      : '',
    failed
      ? t('project:price-incomplete-needs-attention', {
          defaultValue:
            'Some estimates need attention. Review the affected parts for available recovery options.',
        })
      : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <Tooltip title={`${affectedParts} ${explanation}`} describeChild>
      <Box
        component="span"
        role="status"
        tabIndex={0}
        aria-label={t('project:net-sales-price-is-incomplete', {
          defaultValue: 'Net sales price is incomplete',
        })}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.25,
          typography: 'caption',
          whiteSpace: 'nowrap',
          color: 'text.primary',
          cursor: 'help',
          '&:focus-visible': {
            outline: '2px solid',
            outlineColor: 'primary.main',
            outlineOffset: 2,
          },
        }}
      >
        <WarningAmberOutlined
          sx={{
            fontSize: 14,
            color: (theme) =>
              theme.palette.mode === 'dark'
                ? theme.palette.warning.light
                : theme.palette.warning.dark,
          }}
        />
        {t('project:price-incomplete', { defaultValue: 'Incomplete' })}
      </Box>
    </Tooltip>
  )
}
